import React from 'react'
import { Outlet } from 'react-router-dom'
import MainNav from '../nav/MainNav'
import Footer from './Footer'

interface AppShellProps {
  children?: React.ReactNode
}

export default function AppShell({ children }: AppShellProps) {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col">
      {/* Skip to main content for accessibility */}
      <a 
        href="#main-content" 
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 bg-primary-600 text-white px-3 py-2 rounded-md z-50"
      >
        Skip to main content
      </a>
      
      <MainNav />
      
      <main id="main-content" className="flex-1">
        {children || <Outlet />}
      </main>
      
      <Footer />
    </div>
  )
}
